export const loadScriptByCode = (code: string, async?: boolean): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.innerText = code;
    if (async) {
      script.async = async;
    }
    script.onload = () => resolve();
    script.onerror = () => reject();
    document.body.appendChild(script);
  });
};
